import BMXModal from "../../../../Components/Modals/BMXModal/BMXModal";
import { connectModal } from "redux-modal";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ServiceContinuationListModalForm from "../../Forms/ServiceForms/ServiceContinuationListForm/ServiceContinuationListForm";

const ServiceContinuationListModal = (props) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(0);
  const [steps, setSteps] = useState([
    { title: t("global:service.continuationList"), error: false }
  ]);

  const formName = "ServiceContinuationListForm";
  const { handleHide, show } = props;
 

  return (
    <BMXModal
      activeStep={step}
      setStep={setStep}
      open={show}
      width={"600px"}
      height={"500px"}
      onClose={handleHide}
      header={props.header}

      steps={steps}
    >
      <ServiceContinuationListModalForm
        steps={steps}
        step={step}
        setStep={setStep}
        handleHide={handleHide}
        formName={formName}
        {...props}
      />
    </BMXModal>
  );
};

export default connectModal({ name: "ServiceContinuationListModal" })(ServiceContinuationListModal);
